import { ImageIcon, FileText } from 'lucide-react';
import React from 'react';
import './branding.css';
import { BrandColorPicker } from './BrandColorPicker';
import { LogoLivePreview } from './LogoLivePreview';
import { LogoStyleSelector } from './LogoStyleSelector';
import { LogoUploader } from './LogoUploader';
import { ReleaseNotesFieldPicker } from './ReleaseNotesFieldPicker';
import { SystemRequirementsEditor } from './SystemRequirementsEditor';

export interface ProductBrandingPanelProps {
  productId: string | null;
}

export const ProductBrandingPanel: React.FC<ProductBrandingPanelProps> = ({ productId }) => {
  return (
    <>
      <div className="card-section" id="reports-branding">
        <div className="rb-section-header">
          <div className="rb-section-header__icon">
            <ImageIcon size={18} aria-hidden="true" />
          </div>
          <div className="rb-section-header__text">
            <h2 className="rb-section-header__title">Reports &amp; branding</h2>
            <p className="rb-section-header__desc">
              Logo, brand color and content settings used by the Reports page when rendering covers,
              headers and release notes.
            </p>
          </div>
        </div>

        <div className="rb-branding-panel__body">
          <div
            className="rb-branding-panel__group rb-branding-panel__group--logo"
            data-anchor="logo"
          >
            <div className="rb-branding-panel__group-header">
              <h3 className="rb-branding-panel__group-title">Logo</h3>
              <p className="rb-branding-panel__group-sub">PNG or SVG · ≤ 1 MB</p>
            </div>
            <div className="rb-branding-panel__logo-grid">
              <LogoUploader productId={productId} />
              <LogoLivePreview productId={productId} />
            </div>
          </div>

          <div className="rb-branding-panel__group" data-anchor="logo-style">
            <div className="rb-branding-panel__group-header">
              <h3 className="rb-branding-panel__group-title">Logo style</h3>
              <p className="rb-branding-panel__group-sub">
                Controls the plate around the logo on dark or coloured surfaces.
              </p>
            </div>
            <LogoStyleSelector productId={productId} />
          </div>

          <div className="rb-branding-panel__group" data-anchor="brand-color">
            <div className="rb-branding-panel__group-header">
              <h3 className="rb-branding-panel__group-title">Brand color</h3>
              <p className="rb-branding-panel__group-sub">
                Used for the cover band, page accents and PPTX slide master.
              </p>
            </div>
            <BrandColorPicker productId={productId} />
          </div>
        </div>
      </div>

      <div className="card-section" id="release-notes-field">
        <ReleaseNotesFieldPicker productId={productId} />
      </div>

      <div className="card-section">
        <div className="rb-section-header">
          <div className="rb-section-header__icon rb-section-header__icon--neutral">
            <FileText size={18} aria-hidden="true" />
          </div>
          <div className="rb-section-header__text">
            <h2 className="rb-section-header__title">System requirements</h2>
            <p className="rb-section-header__desc">
              Auto-injected into Release Notes (Internal) reports between the Cover page and the
              features list. Leave empty to skip.
            </p>
          </div>
        </div>
        <SystemRequirementsEditor productId={productId} />
      </div>
    </>
  );
};
